import { withCompInfo } from '@wix/editor-elements-integrations'
import type { VectorImageCssVars } from '../VectorImage/VectorImage'
import { getVectorImageCSS } from '../VectorImage/VectorImageHelpers'
import type { VideoBoxControlsDefinition } from './VideoBoxControls'
import { getVideoControlsDesignData } from './videoBoxUtils'

const PLAY_ICON_NAME = 'playButton'

export const css = withCompInfo<VectorImageCssVars, VideoBoxControlsDefinition>()(
	['compDesign', 'styleProperties', 'siteColors'],
	({ compDesign, styleProperties, siteColors }) => {
		const { resolvedSvg, design } = getVideoControlsDesignData(
			compDesign.icons,
			compDesign.iconsDefaultDesign,
			PLAY_ICON_NAME
		)

		return getVectorImageCSS({
			resolvedSvg,
			design,
			styleProperties,
			siteColors,
		})
	}
)
